import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=48c89c35&scoped=true"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=48c89c35&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c89c35",
  null
  
)

export default component.exports